import { createFileRoute, redirect } from '@tanstack/react-router'

// Legacy route: the old "Scam Defense Training" system was retired in the
// 2026-06 IA consolidation (TD-016). Everything lives under Learn now.
export const Route = createFileRoute('/_auth/training')({
  beforeLoad: () => {
    throw redirect({ to: '/learn', search: { tab: undefined, tour: undefined, invitationcode: undefined, __clerk_ticket: undefined }, replace: true })
  },
})
